import { Subject } from 'rxjs/Subject';
import { VetsService } from './../../../auth/_services/vets.service';
import { Vet } from './../../../auth/_models/vet';
import { Observable } from 'rxjs/Observable';
import { Component, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import { takeUntil } from 'rxjs/operators';

declare let CustomScript: any;

@Component({
  selector: 'app-vet-list',
  templateUrl: './vet-list.component.html',
  styleUrls: ['./vet-list.component.css']
})
export class VetListComponent implements OnInit, AfterViewInit, OnDestroy {

  vets: Array<Vet>;
  unsub;

  constructor(
    private _service: VetsService,
  ) {
    this.unsub = new Subject();
  }

  ngAfterViewInit() {
    CustomScript.initDatatableAdvanced(
      {
        targets: 4
      }
    );
  }

  ngOnInit() {
    this._service.getVets()
      .pipe(takeUntil(this.unsub))
      .subscribe(vets => {
        this.vets = vets;
      });
  }

  onSelect(vet: Vet) {
  }

  ngOnDestroy() {
    this.unsub.next();
    this.unsub.complete();
  }

}
